import { mockProgrammes } from '../data/mockData';

const STORAGE_KEY = 'safeguardpro_programmes';

export default class ProgrammeService {
  list() {
    if (typeof window === 'undefined') return mockProgrammes;
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return mockProgrammes;
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed) && parsed.length) return parsed;
      return mockProgrammes;
    } catch (error) {
      return mockProgrammes;
    }
  }

  save(programmes) {
    if (typeof window === 'undefined') return;
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(programmes));
  }

  add(programme) {
    const next = [...this.list(), programme];
    this.save(next);
    return next;
  }

  update(programme) {
    const next = this.list().map((item) => (item.id === programme.id ? programme : item));
    this.save(next);
    return next;
  }
}
